import { AppointmentAdvancePayment } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { AppointmentDetails } from '@dreryk/egabinet-appointment-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import {
   AppointmentBeginDateTextView,
   AppointmentPatientTextView,
   AppointmentPractitionerTextView,
} from '~libs.desktop.shared.appointment';

import { AdvancePaymentPaidAmountTextView } from '../../components/AdvancePaymentPaidAmountTextView';
import { AdvancePaymentPendingOnlinePaymentsTotalAmountTextView } from '../../components/AdvancePaymentPendingOnlinePaymentsTotalAmountTextView';
import { AdvancePaymentRefundsTotalAmountTextView } from '../../components/AdvancePaymentRefundsTotalAmountTextView';
import { AdvancePaymentRequiredAmountTextView } from '../../components/AdvancePaymentRequiredAmountTextView';
import { AdvancePaymentMethodTypeTextView } from '../../components/AdvancePaymentMethodTypeTextView';
import { AdvancePaymentRefundToBeCreatedTypeTextView } from '../../components/AdvancePaymentRefundToBeCreatedTypeTextView';

import { OneColumnSpan, TwoColumnsGrid } from './AdvancePaymentPaidView.styled';

type AdvancePaymentPaidViewProps = {
   appointmentDetails: AppointmentDetails;
   advancePayment: AppointmentAdvancePayment;
};

export const AdvancePaymentPaidView = (props: AdvancePaymentPaidViewProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'20px'}>
         <TwoColumnsGrid>
            <AppointmentBeginDateTextView beginDate={props.appointmentDetails.beginDate} />
            <AppointmentPatientTextView patient={props.appointmentDetails.patient} />

            <OneColumnSpan>
               <AppointmentPractitionerTextView practitioner={props.appointmentDetails.practitioner} />
            </OneColumnSpan>

            <AdvancePaymentRequiredAmountTextView requiredAmount={props.advancePayment.requiredAmount} />
            <AdvancePaymentPaidAmountTextView
               paidAmount={props.advancePayment.paidAmount}
               requiredAmount={props.advancePayment.requiredAmount}
            />

            <AdvancePaymentPendingOnlinePaymentsTotalAmountTextView
               pendingOnlinePaymentsTotalAmount={props.advancePayment.pendingOnlinePaymentsTotalAmount}
            />
            <AdvancePaymentRefundsTotalAmountTextView refundsTotalAmount={props.advancePayment.refundsTotalAmount} />

            <AdvancePaymentMethodTypeTextView paymentMethodType={props.advancePayment.paymentMethod} />
            <AdvancePaymentRefundToBeCreatedTypeTextView
               refundToBeCreatedMethodType={props.advancePayment.refundToBeCreatedMethod}
            />
         </TwoColumnsGrid>
      </StyledFlex>
   );
};
